import { ReactElement } from 'react'
import BaseLayout from 'src/v3/components/base-layout'
import {
  AnalyticsIcon,
  AssignmentIcon,
  DashboardIcon,
  GroupIcon,
  LinkedServiceIcon,
  RosterIcon,
  TrainingSeriesIcon,
} from '../core/icons'

interface Props {
  children: ReactElement | ReactElement[]
}

export default ({ children }: Props): ReactElement => (
  <BaseLayout
    children={children}
    domain="manage"
    role="manager"
    subMenuItems={[
      { name: 'Dashboard', route: '/', icon: <DashboardIcon /> },
      { name: 'CE Analytics', route: '/analytics/ce', icon: <AnalyticsIcon /> },
      {
        name: 'Linked Service',
        route: '/linked-service',
        icon: <LinkedServiceIcon />,
      },
      { name: 'Roster', route: '/roster', icon: <RosterIcon /> },
      { name: 'Assignments', route: '/assignments', icon: <AssignmentIcon /> },
      {
        name: 'Training Series',
        route: '/assignments/training-series',
        subMenu: true,
        icon: <TrainingSeriesIcon />,
      },
      { name: 'Groups', route: '/groups', icon: <GroupIcon /> },
    ]}
  />
)
